"use client";

import dynamic from "next/dynamic";
import { PageLoader } from "@/components/BrandLoader";

const NotFound = dynamic(() => import("@/views/NotFound"), {
  ssr: false,
  loading: () => <PageLoader />,
});

export default function Page() {
  return <NotFound />;
}
